import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const carsReducer = foxGridReducer(gridNames.cars);

export default carsReducer;
